import React from 'react';
import type { Item } from '@aha-app/selectro-v2';
import { resolveAttribute } from '../../../SelectroV2/Templates/helpers';

interface AvatarsProps {
  users: Item[];
  noneSelected: string;
}

const Avatars: React.FC<AvatarsProps> = ({ users, noneSelected }) => {
  const showEllipsis = users.length > 5;
  return (
    <>
      <>
        {users.slice(0, 5).map(user => (
          <div className='mr-1' key={user.value}>
            <aha-avatar
              size={18}
              src={resolveAttribute(user, 'avatar') || null}
              name={user.text}
              label={resolveAttribute(user, 'initials')}
              data-testid='aha-avatar'
            />
          </div>
        ))}
        {showEllipsis && (
          <i className='fa-solid fa-ellipsis' data-testid='watchers_ellipsis' />
        )}
      </>
      {users.length <= 0 && noneSelected}
    </>
  );
};

export default Avatars;
